/* Shared renderer for the custom product-card star ratings (#459, #460). */
(function () {
  if (window.StashStarRating) return;

  var INK = 'var(--stash-star-color, #443C31)';

  function apply(container, rating) {
    var svg = container.querySelector('.rating-stars');
    rating = rating === null || rating === '' ? NaN : Number(rating);
    if (!svg || !isFinite(rating)) return;

    // The markup ships hidden so a missing helper never shows five empty outlines for a rated product.
    svg.style.visibility = '';

    // #511: the stars are the only carrier of the rating, so name the svg (the paths are presentational children
    // of role="img"). The container may carry a localised template; the fallback keeps JS-built cards working.
    var template = container.getAttribute('data-rating-label') || '__RATING__ out of 5 stars';
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', template.replace('__RATING__', String(Math.round(rating * 10) / 10)));
    svg.setAttribute('focusable', 'false');

    // Whole stars are solid; a partial star is left as an outline (as the old 50%-opacity star was lighter),
    // so a 4.7 reads as four stars rather than five. The stroke on the svg draws every outline.
    svg.querySelectorAll('path').forEach(function (star, index) {
      var fraction = Math.round((rating - index) * 100) / 100;

      // Clears the old inline opacity and anything a previous call left behind.
      star.removeAttribute('style');
      star.setAttribute('fill', fraction >= 0.995 ? INK : 'none');
    });
  }

  window.StashStarRating = { apply: apply };
})();
